import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { login } from '../Models/login';
import { update } from '../Models/update';
import { environment } from 'src/environments/environment';
import { deactivated } from '../Models/deactivated';
import { displaynames, UserItem, UsersApiResponse } from '../Models/Users';
import { guide } from '../Models/guide';
import { Booking, BookingCancellationReason, BookingDetailsOutput, CancellationDetails, PaginatedResult } from '../Models/booking';
import { bookingdashboard, BookingOverview, dashboard, MonthlyRevenue } from '../Models/dashboard';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

    baseurl=`${environment.baseUrl}`




  constructor(private http:HttpClient) { }

private getAuthHeaders(): HttpHeaders {
  const token = sessionStorage.getItem('token'); // or localStorage.getItem('token')
  return new HttpHeaders({
    'Authorization': `Bearer ${token}`
  });
}


DeactivatedUser(userId: number, updatedBy: number): Observable<deactivated> {
  debugger;
  // PUT request with userId and deactivatedBy as query params, empty body
  return this.http.put<deactivated>(
    `${this.baseurl}/admin/deactivate-user?userId=${userId}&deactivatedBy=${updatedBy}`,
    {}
  );
}
getAllUsers(
  searchText: string,
  pageNumber: number = 1,
  pageSize: number = 10,
  roleId?: number
): Observable<UsersApiResponse> {
  const headers = this.getAuthHeaders();
  let params = new HttpParams()
    .set('searchTerm', searchText)
    .set('pageNumber', pageNumber.toString())
    .set('pageSize', pageSize.toString());

  if (roleId) {
    params = params.set('roleId', roleId.toString());
  }

  return this.http.get<UsersApiResponse>(`${this.baseurl}/admin/all-users`, { headers, params }).pipe(
    map((res) => {
      const mappedItems = res.data.items.map((item) => {
        return {
          ...item,
          tourGuideUserId: item.tourGuideId ?? 0,
          imageUrl: item.profilePhotoUrl ?? '',
        };
      });

      return {
        ...res,
        data: {
          ...res.data,
          items: mappedItems
        }
      };
    })
  );
}


ApproveTouGuideReq(tourguideId:number,approvedBy:number){
 return this.http.put(`${this.baseurl}/admin/approve-tourguide?tourguideId=${tourguideId}&approvedBy=${approvedBy}`,{});
}



 gettourguide(searchText: string, pageNumber: number, pageSize: number): Observable<guide> {
    let params = new HttpParams()
      .set('searchText', searchText)
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    return this.http.get<guide>(`${this.baseurl}/admin/tourguides/pending-requests`, { params });
  }

getTouristBookingHistory(
  touristUserId: number,
  pageNumber: number,
  pageSize: number,
  searchText: string = '',
  bookingStatuses: string[] = []
) {
  let params = new HttpParams()
    .set('pageNumber', pageNumber.toString())
    .set('pageSize', pageSize.toString())
    .set('searchText', searchText)
    .set('isPaginationRequired', true);

  bookingStatuses.forEach(status => {
    params = params.append('bookingStatuses', status);
  });

  return this.http.get<PaginatedResult<Booking>>(
    `${this.baseurl}/booking/tourists/${touristUserId}/bookings`,
    { params }
  );
}



getGuideBookingHistory(
  guideUserId: number,
  pageNumber: number,
  pageSize: number,
  searchText: string = '',
  bookingStatuses: string[] = []
) {
  let params = new HttpParams()
    .set('pageNumber', pageNumber.toString())
    .set('pageSize', pageSize.toString())
    .set('searchText', searchText)
    .set('isPaginationRequired', true);

  bookingStatuses.forEach(status => {
    params = params.append('bookingStatuses', status);
  });

  return this.http.get<PaginatedResult<Booking>>(
    `${this.baseurl}/booking/tour-guide/${guideUserId}/bookings`,
    { params }
  );
}




uploadUserProfileImage(userId: number, image: File): Observable<any> {
  const formData = new FormData();
  formData.append('ProfileImage', image);

  return this.http.post(`${this.baseurl}/users/${userId}/profile-image`, formData);
}
Updatename(firstname: string, lastname: string,userid:number): Observable<UserItem> {
  const body = { firstname, lastname,userid };
  return this.http.put<UserItem>(`${this.baseurl}/users/update-user-names`, body);
}
Displaynameupdate(userid: number, displayname: string): Observable<UserItem> {
  debugger
  const body = { userid, displayname };
  return this.http.put<UserItem>(`${this.baseurl}/admin/update-displayname`, body);
}

 getUserDashboardData(): Observable<dashboard> {
    return this.http.get<dashboard>(`${this.baseurl}/admin/users/details-dashboard`);
  }

 getbookingDashboardData(): Observable<bookingdashboard> {
    return this.http.get<bookingdashboard>(`${this.baseurl}/admin/booking/dashboard`);
  }

  getMonthlyRevenue(): Observable<MonthlyRevenue> {
    return this.http.get<MonthlyRevenue>(`${this.baseurl}/transaction/monthly-revenue`);
  }

rejectbookingbyadmin(tourGuideId: number, reasonId: number, rejectedBy: number, optionalReason: string): Observable<any> {
  const body = { tourGuideId, reasonId, rejectedBy, optionalReason };
  return this.http.patch<any>(`${this.baseurl}/admin/tourguide/reject-application`, body);
}
getreasonforreject():Observable<any>
{
  return this.http.get<any>(`${this.baseurl}/admin/tourguide/rejection-reasons`);
}
getBookingOverview() {
  return this.http.get<BookingOverview>(`${this.baseurl}/booking/overview`);
}
sendrejectmail(email:string,tourGuideName:string,reason:string,optionalReason:string):Observable<any>
{
   const body = { email, tourGuideName,reason,optionalReason};
return this.http.post<any>(`${this.baseurl}/email/send-rejection-email`,body);
}
cancelbookingbyadmin( bookingId: number, cancelledbyuser: number, reasonId: number, optReason: string): Observable<any> {
  const params = {
    bookingId: bookingId.toString(),
    cancelledbyuser: cancelledbyuser.toString(),
    reasonId: reasonId.toString()
  };

  return this.http.patch<any>(`${this.baseurl}/admin/cancel-booking`,optReason,  { params } );
}


getreasonforbooking():Observable<any>
{
  return this.http.get<BookingCancellationReason[]>(`${this.baseurl}/admin/booking/cancellation-reasons`);
}

sendtomailoncancel(cancelation:CancellationDetails):Observable<CancellationDetails>
{
return this.http.post<CancellationDetails>(`${this.baseurl}/email/booking-cancel-email`,cancelation)
}
SendWelcomeEmail(email: string, guideName: string, tourGuideId: number): Observable<any> {
  const body = { tourGuideId,email, guideName,  };
  return this.http.post(`${this.baseurl}/email/send-guide-welcome-mail`, body);

}


}












